import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M8.586 2.586C8.96 2.21 9.47 2 10 2h4c.53 0 1.04.21 1.414.586C15.79 2.96 16 3.47 16 4v2h4c.552 0 1 .448 1 1s-.448 1-1 1h-.069l-.8 11.213c-.055.757-.393 1.465-.948 1.982-.556.517-1.286.805-2.045.805H7.862c-.759 0-1.49-.288-2.045-.805-.555-.517-.894-1.225-.947-1.982L4.069 8H4c-.552 0-1-.448-1-1s.448-1 1-1h4V4c0-.53.21-1.04.586-1.414zM10 6h4V4h-4v2zM6.074 8l.79 11.07c.018.253.131.49.316.662.186.172.43.268.682.268h8.276c.253 0 .496-.096.682-.268.185-.173.298-.409.316-.661L17.925 8H6.074zM10 10c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1s-1-.448-1-1v-6c0-.552.448-1 1-1zm4 0c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1s-1-.448-1-1v-6c0-.552.448-1 1-1z",
  "clip-rule": "evenodd",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}